import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query';

export function isSharesproFetchQueryError(
  error: unknown
): error is FetchBaseQueryError {
  return (
    typeof error === 'object' &&
    error != null &&
    'status' in error &&
    'data' in error &&
    typeof error.data === 'object' &&
    error.data !== null &&
    'error_code' in error.data &&
    'error_message' in error.data &&
    'field_errors' in error.data
  );
}
